import React from 'react';

function About() {
  return (
    <section id="about">
      <h2>About Us</h2>
      <p>
        CONNECT ALL (SL) LTD is a consulting company focused on delivering 
        innovative solutions in business strategy, technology, and operations.
      </p>
    </section>
  );
}

export default About;
